import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { DataGrid, GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { koKR } from '@mui/x-data-grid/locales';
import { Box, Typography, Button, Autocomplete } from '@mui/material';
import api from '../api/axiosConfig';
import TextField from '@mui/material/TextField';

export default function FieldAutocomplete({ onFieldSelect }) {
    const [fieldOptions, setFieldOptions] = useState([]);
    const [fieldId, setFieldId] = useState('');
    const [fieldInput, setFieldInput] = useState('');
    const selectedOption = useMemo(() =>
        fieldOptions.find(o => String(o.FIELD_ID) === String(fieldId)) || null,
        [fieldOptions, fieldId]
    );

    useEffect(() => {
        api
            .get(`/api/fieldList`)
            .then(res => {
                const uniq = (res.data || []).filter(
                    (it, idx, arr) => idx === arr.findIndex(t => t.FIELD_ID === it.FIELD_ID)
                );
                setFieldOptions(uniq);
            })
            .catch(err => console.error("현장 옵션 로드 실패:", err));
    }, []);
 

    return (
        <div>
            <div className="filter-item gh-field">
                <label>현장</label>
                <Autocomplete
                    options={fieldOptions}
                    value={selectedOption}
                    inputValue={fieldInput}
                    onInputChange={(_, v) => setFieldInput(v)}
                    onChange={(_, v) => {
                        const newFieldId = v ? v.FIELD_ID : '';
                        setFieldId(newFieldId);
                        
                        if (onFieldSelect) {
                            onFieldSelect(newFieldId); 
                        }
                    }}

                    getOptionLabel={(o) => o?.FIELD_NAME || ''}
                    isOptionEqualToValue={(o, v) => o?.FIELD_ID === v?.FIELD_ID}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder="현장 선택"
                            variant="standard"
                            InputProps={{ ...params.InputProps, disableUnderline: true }}
                            
                            sx={{ minWidth: 260 }}
                        />
                    )}
                    clearOnBlur={false}
                />
            </div>

        </div>

    );
}